import { c as _c } from "react/compiler-runtime";
import type { AgentMcpServer } from '@onefootprint/request-types/dashboard';
import { useState } from 'react';
import { useEventListener, useInterval } from 'usehooks-ts';
import { MCP_OAUTH_CALLBACK_ROUTE, MCP_OAUTH_MESSAGE_TYPE } from '@/config/constants';
const POPUP_FEATURES = 'popup,width=600,height=720';
const CLOSED_POLL_MS = 500;
type UseMcpOauthPopupOptions = {
  onComplete: (server: AgentMcpServer) => void;
};
const mcpOauthRedirectUri = () => `${window.location.origin}${MCP_OAUTH_CALLBACK_ROUTE}`;
const parseCompleteMessage = (data: unknown): AgentMcpServer | null => {
  if (typeof data !== 'object' || data === null) return null;
  const message = data as {
    type?: unknown;
    server?: unknown;
  };
  if (message.type !== MCP_OAUTH_MESSAGE_TYPE || typeof message.server !== 'object' || message.server === null) {
    return null;
  }
  return message.server as AgentMcpServer;
};

/** Opens the provider's authorization page in a popup and resolves when the callback page reports
 * the saved server. `isWaiting` drops on its own if the user closes the popup. */
const useMcpOauthPopup = t0 => {
  const $ = _c(13);
  const {
    onComplete
  } = t0;
  const [popup, setPopup] = useState(null);
  const [isWaiting, setIsWaiting] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = authorizationUrl => {
      const opened = window.open(authorizationUrl, "footprint-mcp-oauth", POPUP_FEATURES);
      setPopup(opened);
      setIsWaiting(true);
      return opened !== null;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const open = t1;
  let t2;
  if ($[1] !== popup) {
    t2 = () => {
      popup?.close();
      setPopup(null);
      setIsWaiting(false);
    };
    $[1] = popup;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const cancel = t2;
  let t3;
  if ($[3] !== cancel || $[4] !== isWaiting || $[5] !== onComplete) {
    t3 = event => {
      if (!isWaiting || event.origin !== window.location.origin) {
        return;
      }
      const server = parseCompleteMessage(event.data);
      if (!server) {
        return;
      }
      cancel();
      onComplete(server);
    };
    $[3] = cancel;
    $[4] = isWaiting;
    $[5] = onComplete;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEventListener("message", t3);
  let t4;
  if ($[7] !== cancel || $[8] !== popup?.closed) {
    t4 = () => {
      if (popup?.closed) {
        cancel();
      }
    };
    $[7] = cancel;
    $[8] = popup?.closed;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  useInterval(t4, isWaiting && popup ? CLOSED_POLL_MS : null);
  let t5;
  if ($[10] !== cancel || $[11] !== isWaiting) {
    t5 = {
      open,
      cancel,
      isWaiting
    };
    $[10] = cancel;
    $[11] = isWaiting;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export { mcpOauthRedirectUri };
export default useMcpOauthPopup;